import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductListActions from "@tIntermatic/Overrides/Widgets/ProductList/ProductListActions";
import INTProductCompare from "@tIntermatic/Widgets/ProductList/INTProductCompare";
import INTProductImage from "@tIntermatic/Widgets/ProductList/INTProductImage";
import INTPromoSlot from "@tIntermatic/Widgets/ProductList/INTPromoSlot";

import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    currentLanguage: state.context.session.language,
    currentWebsiteName: state.context.website.name,
});

type Props = ProductCardSelections & HasProduct & ReturnType<typeof mapStateToProps>;

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    modelNumber?: InjectableCss;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-bottom: 10px;
            border: 1px solid #e1e1e1;
            background-color: #ffffff;
            position: relative;
            div[data-test-selector^="productListProductImage"] {
                img {
                    min-width: 100%;
                    height: 300px;
                    object-fit: contain;
                }
            }
            span[data-test-selector^="productNumber"] {
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 17px;
                padding-top: 10px;
                padding-bottom: 70px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding-top: 12px;
                            `,
                            css`
                                padding-top: 12px;
                            `,
                            css`
                                padding-top: 10px;
                            `,
                            css`
                                padding-top: 10px;
                            `,
                            css`
                                padding-top: 10px;
                            `,
                        ],
                        "min",
                    )}
            }
            div[data-test-selector^="product-compare"] {
                padding-top: 0px;
                padding-bottom: 16.5px;
                // position: absolute;
                // bottom: 0;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding-top: 0px;
                                // bottom: 27.5px;
                            `,
                            css`
                                padding-top: 0px;
                                // bottom: 27.5px;
                            `,
                            css`
                                padding-top: 0px;
                                // bottom: 0;
                            `,
                            css`
                                padding-top: 0px;
                                // bottom: 0;
                            `,
                            css`
                                padding-top: 0px;
                                // bottom: 0;
                            `,
                        ],
                        "min",
                    )}
            }
            div[data-test-selector="product-information"] {
                padding: 0 20.5px;
                display: flex;
                flex-direction: column;
                height: 100%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: 0 20.5px;
                            `,
                            css`
                                padding: 0 20.5px;
                            `,
                            css`
                                padding: 0 20.5px;
                            `,
                            css`
                                padding: 0 20.5px;
                            `,
                            css`
                                padding: 0 20.5px;
                            `,
                        ],
                        "min",
                    )}
            }
            a[data-test-selector^="productDescriptionLink"] {
                padding: 0;
                span {
                    color: #33333a !important;
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 19px;
                    &:hover {
                        color: #006bc0 !important;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding-top: 28px;
                                    font-size: 21px;
                                    font-weight: 600;
                                    letter-spacing: 0;
                                    line-height: 25px;
                                `,
                                css`
                                    padding-top: 28px;
                                    font-size: 21px;
                                    font-weight: 600;
                                    letter-spacing: 0;
                                    line-height: 25px;
                                `,
                                css`
                                    padding-top: 17px;
                                    font-size: 16px;
                                    font-weight: 500;
                                    letter-spacing: 0;
                                    line-height: 19px;
                                `,
                                css`
                                    padding-top: 17px;
                                    font-size: 16px;
                                    font-weight: 500;
                                    letter-spacing: 0;
                                    line-height: 19px;
                                `,
                                css`
                                    padding-top: 17px;
                                    font-size: 16px;
                                    font-weight: 500;
                                    letter-spacing: 0;
                                    line-height: 19px;
                                `,
                            ],
                            "min",
                        )}
                }
            }
            button[data-test-selector^="actionsAddToCart"] {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            padding: 0px 11px;
                            span {
                                letter-spacing: 1px;
                            }
                        `,
                        css`
                            padding:0px 19px;
                        `,
                    ])}
            }
            div[data-test-selector^="productNotPurchased"] {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            span {
                                font-size:14px;
                            }
                        `,
                        null,
                    ])}
            }
        `,
    },
    modelNumber: {
        css: css`
            border: 1px solid red !important;
        `,
    },
    imageWrapper: {
        css: css`
            height: 300px;
            margin: 0 auto;
            // padding: 10px 50px;
            padding: 0 20.5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 40.5px;
                        `,
                        css`
                            padding: 0 40.5px;
                        `,
                        css`
                            padding: 0 20.5px;
                        `,
                        css`
                            padding: 0 20.5px;
                        `,
                        css`
                            padding: 0 20.5px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    currentLanguage,
    currentWebsiteName,
}) => {
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            {product.isSponsored && <INTPromoSlot></INTPromoSlot>}
            <StyledWrapper {...styles.imageWrapper}>
                <INTProductImage showImage={showImage} />
            </StyledWrapper>
            <StyledWrapper data-test-selector="product-information">
                <ProductListProductInformation
                    showAttributes={showAttributes}
                    showAvailability={showAvailability}
                    showBrand={showBrand}
                    showPartNumbers={showPartNumbers}
                    showTitle={showTitle}
                />
                {currentWebsiteName.toLowerCase() === "main" && currentLanguage?.languageCode.toLowerCase() === "en" && (
                    <StyledWrapper
                        css={css`
                            display: flex;
                            height: 100%;
                            align-items: flex-start;
                        `}
                    >
                        <INTProductCompare showCompare={showCompare} />
                    </StyledWrapper>
                )}
                {!(
                    currentWebsiteName.toLowerCase() === "main" && currentLanguage?.languageCode.toLowerCase() === "en"
                ) && (
                    <StyledWrapper
                        css={css`
                            display: flex;
                            align-items: flex-start;
                        `}
                    >
                        <INTProductCompare showCompare={showCompare} />
                    </StyledWrapper>
                )}
                {currentWebsiteName.toLowerCase() === "main" &&
                    currentLanguage?.languageCode.toLowerCase() === "en" && (
                        <ProductListActions showPrice={showPrice} showAvailability={showAvailability} />
                    )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(withProduct(ProductListProductGridCard));
